import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import axios from "axios"

// axios.defaults.baseURL = "https://www.timemarking.com/";
if (process.env.NODE_ENV === 'production') {
  axios.defaults.baseURL = "/opendata/api";
}
else {
  axios.defaults.baseURL = "http://localhost:8000";
}

import 'bootstrap/dist/css/bootstrap.min.css'
import "bootstrap"

import 'bootstrap-icons/font/bootstrap-icons.css'


// import { createBootstrap } from 'bootstrap-vue-next'
// import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

router.afterEach((to, from, next) => {

  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = `${to.meta.title}`
  }
  // // chrome
  // document.body.scrollTop = 0
  // // firefox
  // document.documentElement.scrollTop = 0
  // // safari
  // window.pageYOffset = 0
  window.scrollTo(0, 0);
  if (typeof (next) == "function") {
    next();
  }
});

const app = createApp(App)
app.use(router)
// app.use(createBootstrap())
app.mount('#app')